import type { TOC } from '@ember/component/template-only'
import { eq } from 'ember-truth-helpers'
import numberSlider from 'teacher-ui-client/modifiers/number-slider'
import type { ThemeKeys } from 'teacher-ui-client/utils/themes'

type TooltipFormatter = (envodedValue: number) => string | number

interface Args {
  theme?: ThemeKeys
  values: number[]
  connect: boolean[]
  range: {
    min: number
    max: number
  }
  step: number
  tooltips: boolean | TooltipFormatter | (boolean | TooltipFormatter)[]
  onUpdateAll?: (encodedValues: number[], handleNumber: number) => unknown
  onUpdateValues?: ((encodedValue: number) => unknown)[]
}

interface Signature {
  Args: Args
  Element: HTMLDivElement
}

export const NumberSliderComponent: TOC<Signature> = <template>
  <div
    class="base-number-slider
      {{if (eq @theme 'blue') 'theme-blue'}}
      {{if (eq @theme 'green') 'theme-green'}}
      hide-inactive-tooltips"
    {{numberSlider
      values=@values
      connect=@connect
      tooltips=@tooltips
      range=@range
      step=@step
      onUpdateValues=@onUpdateValues
      onUpdateAll=@onUpdateAll
    }}
    ...attributes
  ></div>
</template>

export default NumberSliderComponent
